export const planningValidation = {
  planningDate: {
    type: 'string',
    required: {
      value: true,
      when: {
        $isSkipped: {
          eq: false,
        },
      },
    },
  },
  details: {
    type: 'string',
    required: {
      value: true,
      when: {
        $plannedScopeLink: {
          eq: undefined,
        },
        $isSkipped: {
          eq: false,
        },
      },
    },
  },
  plannedScopeLink: {
    type: 'string',
    required: {
      value: true,
      when: {
        $details: {
          eq: undefined,
        },
        $isSkipped: {
          eq: false,
        },
      },
    },
    link: true,
  },
  isSkipped: {
    type: 'boolean',
    required: false,
  },
  skipReason: {
    type: 'string',
    required: {
      value: true,
      when: {
        $isSkipped: {
          eq: true,
        },
      },
    },
  },
};
